import { LinkButton, UIHeading4, UIText2 } from '@cian/ui-kit';
import React, { useCallback } from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './MortgagePaymentInformer.css';

interface IMortgagePaymentTooltipContentProps {
  tooltipTitle: string;
  tooltipLink: string;
  onTooltipLinkClick: () => void;
}

export const MortgagePaymentTooltipContent: React.FC<IMortgagePaymentTooltipContentProps> = ({
  tooltipTitle,
  tooltipLink,
  onTooltipLinkClick,
}) => {
  const clickTrap = useCallback((e: React.MouseEvent) => e.stopPropagation(), []);

  return (
    <div className={styles['tooltip-content']} onClick={clickTrap}>
      <UIHeading4>{tooltipTitle}</UIHeading4>
      <UIText2>
        Рассчитали платёж, исходя из{NBSP}срока кредита 30 лет и{NBSP}первого{NBSP}взноса 20%
      </UIText2>
      <div className={styles['tooltip-actions']}>
        <LinkButton
          size="M"
          href={tooltipLink}
          target="_blank"
          theme="fill_secondary"
          onClick={onTooltipLinkClick}
          data-testid="mortgage-payment-tooltip-link"
          fullWidth
        >
          Подробнее
        </LinkButton>
      </div>
    </div>
  );
};
